// templateImageMap.js
//
// Static template image pairs for the Build Your Ad page.
// base  = blank template with placeholders (card thumbnail)
// final = completed/finalized template (shown on hover / touch)
//
// To add a new template:
//   1. Drop the two images into public/templates/
//   2. Add an entry to TEMPLATES below

export const TEMPLATES = [
  {
    id: 'noland-msrp-12offer',
    name: '12-Vehicle MSRP Mailer',
    type: 'Print',
    size: '5x19.75',
    base:  '/templates/noland-msrp-12offer-base.png',
    final: '/templates/noland-msrp-12offer-final.png',
  },
  {
    id: 'print-3offer',
    name: '3-Offer Print Ad',
    type: 'Print',
    size: '8.5x11',
    base:  '/templates/print-3offer-base.png',
    final: '/templates/print-3offer-final.png',
  },
  {
    id: 'social-1080',
    name: 'Social Media Post',
    type: 'Digital',
    size: '1080x1080',
    base:  '/templates/social-1080-base.png',
    final: '/templates/social-1080-final.png',
  },
  {
    id: 'email-service-600',
    name: 'Service Email',
    type: 'Email',
    size: '600px wide',
    base:  '/templates/email-service-600-base.png',
    final: '/templates/email-service-600-final.png',
  },
];
